import React from 'react'
import ReactDOM from 'react-dom/client'
import { QueryClientProvider } from '@tanstack/react-query'
import { BrowserRouter } from 'react-router-dom'
import { HelmetProvider } from 'react-helmet-async'
import App from './App.tsx'
import { Toaster } from '@/components/ui/toaster'
import './index.css'
import './styles/glassmorphism.css'
import { queryClient } from './lib/queryClient'
import { AuthProvider } from '@/contexts/AuthContext'
import ErrorBoundary from '@/components/ErrorBoundary'
import { setupDevHelpers } from '@/utils/devHelpers'
import { startVersionMonitoring } from '@/utils/versionManager'
import { ThemeProvider } from '@/contexts/ThemeContext'
import { AlertProvider } from '@/components/AlertProvider'
import { ConfirmDialogProvider } from '@/components/ConfirmDialog'
import { GlobalErrorHandler } from '@/components/GlobalErrorHandler'

// Enable client-side debug logs in development so resolver instrumentation is visible
if (import.meta && (import.meta as any).env && (import.meta as any).env.DEV) {
  (window as any).__SMARTCRM_DEBUG__ = true
  setupDevHelpers()
}

// Start version monitoring for automatic cache busting in production
startVersionMonitoring()

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <HelmetProvider>
      <QueryClientProvider client={queryClient}>
        <BrowserRouter>
          <ErrorBoundary>
            <AuthProvider>
              <ThemeProvider>
                <AlertProvider>
                  <ConfirmDialogProvider>
                    <GlobalErrorHandler>
                      <App />
                    </GlobalErrorHandler>
                  </ConfirmDialogProvider>
                </AlertProvider>
              </ThemeProvider>
            </AuthProvider>
          </ErrorBoundary>
        </BrowserRouter>
        <Toaster />
      </QueryClientProvider>
    </HelmetProvider>
  </React.StrictMode>,
)
